module.exports = __webpack_public_path__ + "img/data_empty.19f0cf2f.png";